/**
 * @file: 层板子级排序
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import CodiSystem from '../../codiSystem';
import Utils from '../../utils/util';

function sortLayerCubeByLogic(cubeIds: CubeId[]): CubeId[] {
    let skuCubesCols: Array<Array<CubeId>> = getCabinetColCubes(cubeIds);

    return Utils.expandArray(skuCubesCols);
}

function getCabinetColCubes(cubeIds: CubeId[]): CubeId[][] {
    let skuSortCubes: Array<CubeId> = makeSkuCubesSortList(cubeIds);
    let skuCubesCols: Array<Array<CubeId>> = makeSkuCubesColGroupList(skuSortCubes);

    for (let i: number = 0; i < skuCubesCols.length; i++) {
        skuCubesCols[i] = skuCubeQuickSort(skuCubesCols[i], 'top').reverse();
    }

    return skuCubesCols;
}

/**
 * sku根据posX分组，返回二维数组
 *
 * @param {Array} skuCubes 排完序的sku列表
 * @return {Array} 商品分组列表, 二维数组 [Array, Array]
 */
function makeSkuCubesColGroupList(skuCubes: Array<CubeId>): Array<Array<CubeId>> {
    let result: Array<Array<CubeId>> = [];
    let colGroup: Array<CubeId> = [];

    for (let i: number = 0; i < skuCubes.length; i++) {
        let lastGroupSku: CubeId = colGroup[colGroup.length - 1];

        if (lastGroupSku) {
            let last: number = CodiSystem.getLogicCoordinate(lastGroupSku).left;
            let cur: number = CodiSystem.getLogicCoordinate(skuCubes[i]).left;

            if (last !== cur) {
                result.push(colGroup);
                colGroup = [skuCubes[i]];
                continue;
            }
        }
        colGroup.push(skuCubes[i]);
    }
    result.push(colGroup);

    return result;
}

/**
 * sku列表根据posX从小到大排序
 *
 * @param {Array} skuIds sku列表
 * @return {Array} sku列表
 */
function makeSkuCubesSortList(cubeIds: CubeId[]): Array<CubeId> {
    let skuCubesSort: Array<CubeId> = [];

    cubeIds.forEach((child: CubeId): void => {
        if (CubeTree.isGoods(child)
            || CubeTree.isTextarea(child)
            || CubeTree.isBafflePlate(child)) {
            skuCubesSort.push(child);
        }
    });

    return skuCubeQuickSort(skuCubesSort, 'left');
}

/**
 * skucube快速排序
 *
 * @param {Array} arr skucubes
 * @return {Array}
 */
function skuCubeQuickSort(arr: Array<CubeId>, key: string): Array<CubeId> {
    if (arr.length < 1) return arr;
    let pivotIndex: number = Math.floor(arr.length / 2);
    let pivot: CubeId = arr.splice(pivotIndex, 1)[0];
    let left: Array<CubeId> = [];
    let right: Array<CubeId> = [];

    for (let i: number = 0; i < arr.length; i++) {
        let cur: CubeId = arr[i];
        let curVal: number = CodiSystem.getLogicCoordinate(cur)[key];
        let pivotVal: number = CodiSystem.getLogicCoordinate(pivot)[key];

        if (curVal < pivotVal) {
            left.push(cur);
        } else {
            right.push(cur);
        }
    }

    return skuCubeQuickSort(left, key).concat([pivot], skuCubeQuickSort(right, key));
}

export {
    sortLayerCubeByLogic,
    getCabinetColCubes
};
